<template>
    <iframe v-if="grafToken && finalUrl" :src="finalUrl" width="100%" height="100%" allowfullscreen title="Grafana Analytics" class="grafana-iframe" />
    <div v-else-if="!grafToken" class="loading-container">
        <v-progress-circular indeterminate color="primary" />
        <span class="loading-text">Loading authentication...</span>
    </div>
    <div v-else class="error-container">
        <v-alert type="error">Invalid URL provided</v-alert>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import { getAccessTokenSilentlyOutsideComponent } from '@/lib/auth'

const props = defineProps<{
    url: string
    title?: string
}>()

const grafToken = ref<string | undefined>(undefined)

const finalUrl = computed(() => {
    if (!grafToken.value || !props.url) return null

    try {
        const url = new URL(props.url)

        // Add required query parameters
        url.searchParams.set('kiosk', 'true')
        url.searchParams.set('auth_token', grafToken.value)

        return url.toString()
    } catch (error) {
        console.error('Invalid URL provided:', error)
        return null
    }
})

onMounted(async () => {
    try {
        const token = await getAccessTokenSilentlyOutsideComponent()
        if (token) {
            grafToken.value = token
        } else {
            console.warn('No access token available')
        }
    } catch (error) {
        console.error('Error getting access token:', error)
    }
})
</script>

<style scoped>
.grafana-iframe {
    border: none;
}

.loading-container,
.error-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.loading-text {
    margin-left: 8px;
}
</style>
